module.exports = __webpack_public_path__ + "static/abdo-d933cdfe3004c4d37765ed47a5e76903.jpg";